"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultModel = void 0;
class DefaultModel {
    constructor(_id) {
        this._id = _id;
        this.updated_at = new Date();
        this.created_at = new Date();
    }
    static getValidationMap() {
        return {
            updated_at: 'date',
            created_at: 'date',
        };
    }
}
exports.DefaultModel = DefaultModel;
//# sourceMappingURL=default.model.js.map